import React from "react";
import { RouteObject } from "helpers/tixxt-router";
import DirectoryPage from "components/directory/DirectoryPage";
import GroupMembersPage from "components/directory/GroupMembersPage";

const directoryRoutes: RouteObject[] = [
  { path: "/directory", element: <DirectoryPage preselectedTab="members" /> },
  { path: "/members", element: <DirectoryPage preselectedTab="members" /> },
  { path: "/groups/:groupSlug/members", element: <GroupMembersPage /> },
  { path: "/channels", element: <DirectoryPage preselectedTab="channels" /> },
  {
    path: "/directory/channels",
    element: <DirectoryPage preselectedTab="channels" />,
  },
  {
    path: "/directory/:category_id",
    element: <DirectoryPage preselectedTab="groups" />,
  },
];

export default directoryRoutes;
